var exports = {
  "x": "subscriptionTypeName__9Ts4cK",
};

module.exports = exports;
